import { $axios } from './axios.service'

export function tokenSet(token: string) {
  $axios.setToken(token, 'Bearer')
}

export function tokenReset() {
  $axios.setToken(false)
}
